"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OgcMapFilter = void 0;
var FiltersValues_1 = require("./FiltersValues");
var WFS_1 = require("ol/format/WFS");
var filter_1 = require("ol/format/filter");
var OgcMapFilter = /** @class */ (function () {
    function OgcMapFilter(elementId) {
        var _this = this;
        if (elementId === void 0) { elementId = "mapFilters"; }
        this.getFeatureRequestWithFilter = function (filterOptions, bounds, projection, options) {
            var f = _this.getFilter(filterOptions, bounds, projection, options);
            if (f) {
                options.filter = f;
            }
            return _this.getWfsRequestAsXmlString(options, false);
        };
        this.getFilterOnly = function (filterOptions, bounds, projection, options) {
            var f = _this.getFilter(filterOptions, bounds, projection, options);
            if (f) {
                options.filter = f;
            }
            return _this.getWfsRequestAsXmlString(options, true);
        };
        this.getFilter = function (filterOptions, bounds, projection, options) {
            var self = _this;
            var filters = [];
            var boundsFilter = null;
            if (bounds != null) {
                boundsFilter = filter_1.bbox("Geom", bounds, projection);
                filters.push(boundsFilter);
            }
            //go through each filter options and see if we have a filter
            filterOptions.filters.forEach(function (filterOption) {
                var filter = self.filters.getFilter(filterOption);
                if (filter != null) {
                    var f = new Array();
                    if (Array.isArray(filter.value)) {
                        var filterArray_1 = new Array();
                        filter.value.forEach(function (value) {
                            filterArray_1.push(filter_1.equalTo(filter.name, value));
                        });
                        filters.push(filter_1.or.apply(void 0, filterArray_1));
                    }
                    else {
                        filters.push(filter_1.equalTo(filter.name, filter.value));
                    }
                }
            });
            if (filters.length === 1) {
                return filters[0];
            }
            else if (filters.length > 1) {
                return filter_1.and.apply(void 0, filters);
            }
        };
        this.getWfsRequestAsXmlString = function (options, filterOnly) {
            var featureRequest = new WFS_1.default().writeGetFeature(options);
            //console.log(new XMLSerializer().serializeToString(featureRequest));
            if (filterOnly) {
                var filterStr = new XMLSerializer().serializeToString(featureRequest.firstChild.firstChild);
                filterStr = filterStr.replace(' xmlns="http://www.opengis.net/ogc"', "");
                return filterStr;
            }
            return new XMLSerializer().serializeToString(featureRequest);
        };
        this._filters = new FiltersValues_1.FilterValues(elementId);
    }
    Object.defineProperty(OgcMapFilter.prototype, "filters", {
        get: function () {
            return this._filters;
        },
        enumerable: false,
        configurable: true
    });
    return OgcMapFilter;
}());
exports.OgcMapFilter = OgcMapFilter;
//# sourceMappingURL=OgcMapFilter.js.map